
import { Dialog, Spinner } from 'construct-ui';
import moment from 'moment';
import paginationComponent from '../../components/pagination/pagination.component';
import { FILE_NAME_MAP, formats } from '../../config/constants';
import languageModel from '../../models/language.model';
import AttendanceExcelDownloadView from '../attendance/attendance-excel-download.view';
import ViewBase from '../view-base.view';
import goodMovementModel from '../../models/posm/goods-movement.model';

export const GOODMOVEMENT_MAP_OBJECT = {
  MovementTypeName: "Movement Type",
  MovementControlId: "Movement Code",
  MovementDate: "Date",
  Model: "Item Type",
  BasicModel: "Item Name",
  MovementQty: "Qty",
  UnitPrice: "Unit Price",
  Amount: "Value",
  CalcStockQty: "Total Qty",
  StockValue: "Total Value",
  MovementBy: "Requester",
  FromVendor: "Vendor",
  ToWarehouse: "To Warehouse",
  ToStorage: "To Storage Location",
  RefNo: "Ref No",
  Remarks: "Remarks",
  FileName1: "Proof 1",
  FileName2: "Proof 2",
  FileName3: "Proof 3",
  FileName4: "Proof 4",
  FileName5: "Proof 5",
  FileId1: null,
  FileId2: null,
  FileId3: null,
  FileId4: null,
  FileId5: null,
  RowNum: null,
  MovementId: null,
  MovementType: null,
  GoodsType: null,

}
export const LABEL_GOODMOVEMENT_MAP_OBJECT = {
  MovementTypeName: "LT00001284",
  MovementControlId: "LT00001239",
  MovementType: "LT00001254",
  MovementDate: "LT00000132",
  Model: "LT00001288",
  BasicModel: "LT00001251",
  MovementQty: "LT00001283",
  UnitPrice: "LT00001282",
  Amount: "LT00001098",
  CalcStockQty: "LT00001273",
  StockValue: "LT00001240",
  MovementBy: "LT00001241",
  FromVendor: "LT00001088",
  ToWarehouse: "LT00001246",
  ToStorage: "LT00001247",
  RefNo: "LT00001279",
  Remarks: "LT00000152",
  FileName1: "LT00001248",
  FileName2: "LT00001249",
  FileName3: "LT00001250",
  FileName4: "LT00001251",
  FileName5: "LT00001252",
}

export default function DisplayAllGoodsReceive() {
  ViewBase.call(this);
  let listGoodMovement = [];
  let isExcelDownloadModalOpen = false;


  const closeExcelDownloadModal = () => {
    isExcelDownloadModalOpen = false;
  }
  const parseListGoodMovement = (goodMovementList) => {
    return goodMovementList?.map(item => {
      if (!item) {
        return;
      }
      let warehouses = [];
      for (let props in item) {
        if (!Object.hasOwn(GOODMOVEMENT_MAP_OBJECT, props)) {
          warehouses.push([props, item[props]])
        }
      }
      let newItem = { ...item, warehouses: warehouses }
      return newItem
    })
  }
  const createTableHeader = (listGoodMovement, index) => {
    if (!listGoodMovement.length) {
      return
    }
    const goodMovementObj = listGoodMovement[index];
    let tableHeaders = [];
    for (let props in GOODMOVEMENT_MAP_OBJECT) {
      if (GOODMOVEMENT_MAP_OBJECT[props]) {
        tableHeaders.push([props, GOODMOVEMENT_MAP_OBJECT[props]])
      }
      if (props == "StockValue") {
        goodMovementObj.warehouses.map((item) => {
          tableHeaders.push(["Warehouse", item[0]])
        })
      }
    }
    return tableHeaders;
  }

  let isDownloading = false;

  const onDownloadClick = (downloadFn) => {
    isDownloading = true;
    downloadFn()
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        isDownloading = false;
      })
  }
  return {

    oninit: () => {

    },
    view: (vnode) => {
      listGoodMovement = vnode.attrs.listGoodMovement || [];
      listGoodMovement = parseListGoodMovement(listGoodMovement)
      let height = listGoodMovement?.length > 10 ? "1000px" : "650px";
      return [
        m('.row',
          m('.col-12.attendance',
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.gap-3.mb-2',
                  m('a.btn.btn-primary',
                    {
                      class: !isDownloading && listGoodMovement?.length > 0 ? '' : 'disabled',
                      onclick: () => {
                        onDownloadClick(vnode.attrs.onDownLoadGoodMovement)
                      }
                    },
                    isDownloading
                      ? m(Spinner, {
                        style: 'margin-right: 12px',
                        active: true,
                        size: 'sm'
                      })
                      : m('i.bi.bi-file-earmark-arrow-down-fill')
                    , this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive", { "style": `height : ${height}` },
                      m("table.table.table-hover.table-bordered", [
                        m("thead.thead-bggrey", { "style": "position : sticky ; top :1px; box-shadow: 0px -1px var(--is-link-blue)" },

                          m("tr.align-middle", { style: 'box-shadow: 0px 1px var(--blue-color-light)' }, [
                            m("th", { "scope": "col", "colspan": "10" }),
                            m("th", { "scope": "col", "colspan": listGoodMovement[0]?.warehouses.length, "style": "text-align :center;" }, "Warehouse"),
                            m("th", { "scope": "col", "colspan": "12" }),
                          ]),
                          m("tr.align-middle", createTableHeader(listGoodMovement, 0)?.map((item) => {
                            if (Object.hasOwn(LABEL_GOODMOVEMENT_MAP_OBJECT, item[0])) {
                              return m("th", { "style": "max-width : 320px" }, this.getText(LABEL_GOODMOVEMENT_MAP_OBJECT[item[0]], item[1]))

                            } else {
                              return m("th.text-truncate", { title: item[1], "style": "max-width : 320px" }, item[1])
                            }
                          }))
                        ),
                        m("tbody",
                          (listGoodMovement.length === 0) &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": 27 }, languageModel.getText("EM00000141", "No records found."))
                          ),
                          listGoodMovement.length > 0 &&
                          listGoodMovement.map((att, index) => {
                            return [
                              m("tr.align-middle", createTableHeader(listGoodMovement, index)?.map((item) => {
                                if (item[1] == GOODMOVEMENT_MAP_OBJECT.MovementDate) {
                                  return m("td", moment(att[item[0]], formats.apiDateFormat).format(formats.dateFormat))
                                }
                                if ([
                                  GOODMOVEMENT_MAP_OBJECT.MovementQty,
                                  GOODMOVEMENT_MAP_OBJECT.UnitPrice,
                                  GOODMOVEMENT_MAP_OBJECT.Amount,
                                  GOODMOVEMENT_MAP_OBJECT.CalcStockQty,
                                  GOODMOVEMENT_MAP_OBJECT.StockValue
                                ].includes(item[1])) {
                                  return m("td.text-end", att[item[0]])
                                }
                                if (item[0] == "Warehouse") {
                                  return m("td.text-end", att[item[1]])
                                }
                                if (Object.hasOwn(FILE_NAME_MAP, item[0])) {

                                  return m("td", m("button.btn.btn-link.btn-sm.text-truncate", {
                                    "style": "max-width :200px",
                                    type: 'button',
                                    title: att[item[0]],
                                    onclick: (e) => {
                                      e.preventDefault();
                                      goodMovementModel.downloadProofFile(att[FILE_NAME_MAP[item[0]]], att[item[0]])
                                    },
                                  }, att[item[0]]))
                                }
                                if (item[1] === GOODMOVEMENT_MAP_OBJECT.MovementControlId) {
                                  return m("td", m("button.btn.btn-link", {
                                    onclick: () => { vnode.attrs.onOpenMovementDetail(att[item[0]]) }
                                  }, att[item[0]]))
                                }
                                else {
                                  return m("td.text-truncate", { title: att[item[0]], "style": "max-width : 400px" }, att[item[0]])
                                }

                              })),
                            ]

                          }),
                        )
                      ])
                    ),
                    listGoodMovement.length > 0 &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: vnode.attrs.paginationObj.pageIndex,
                        pageSize: vnode.attrs.paginationObj.pageSize,
                        totalItems: vnode.attrs.totalItems,
                        onPageChanged: (pageIndex) => {
                          vnode.attrs.setPaginationObj({ pageIndex })
                          vnode.attrs.onSearchForGoodMovementList();
                        },
                        onPageSizeChanged: (pageIndex, pageSize) => {
                          vnode.attrs.setPaginationObj({ pageIndex, pageSize });
                          vnode.attrs.onSearchForGoodMovementList();
                        },
                      })
                    )
                  )
                )
              )
            )
            //End List
          ),
        ),

        isExcelDownloadModalOpen &&
        m(Dialog, {
          class: 'modal-body-overflow-visible',
          closeOnOutsideClick: false,
          isOpen: isExcelDownloadModalOpen,
          onClose: closeExcelDownloadModal,
          title: this.getText('LT00000741', 'Attendance Download'),
          content: m(AttendanceExcelDownloadView, {
            data: [],
            onClose: (o) => { isExcelDownloadModalOpen = o; },
          }),
        }),
        this.getBaseViews()
      ];
    },
  };
}
